import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import getTeacherDescriptionCTRL from 'controllers/teacher/getTeacherDescription'
import updateTeacherDescriptionCTRL from 'controllers/teacher/updateTeacherDescription'

import locale from './locale';
import "./Modal.scss";

class ModalBody extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      teacherData: {}
    }

    this.onChange = this.onChange.bind(this)
  }

  componentWillMount(){
    getTeacherDescriptionCTRL(this.props.id)
    .then((res) => {
      let arr = {description: res.description, on_website: res.on_website == 0 ? false : true}
      this.setState({teacherData: arr})
    })
  }

  onChange(value){
    this.setState({teacherData: value})
  }

	render() {
		const {show, proceed, dismiss, cancel, id} = this.props;
    const {teacherData} = this.state

		return (
      <Modal
				className='teacher-description-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Teacher Description", locale)}
				headerIcon="fa icon-indent-right"
        fixedWidth={500}
        contentHeight={300}
        onCloseModalClick={dismiss}
        footerType="grey"
        footerButtons={[
          {
            title: __('Save', locale),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              let data = {description: teacherData.description, on_website: teacherData.on_website ? 1: 0}
              updateTeacherDescriptionCTRL(id, data)
              .then((res) => {
                if(res.result == 'success'){
                  dismiss()
                }
              })
            }
          },
          {
            title: __('Cancel', locale),
            className: 'btn btn-default pull-right',
            onClick: ()=>{
              this.props.dismiss()
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          {...this.props}
          teacherData={this.state.teacherData}
          onChange={this.onChange}
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent }}
         />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/TeacherDescription/ModalBody.js